import { render, staticRenderFns } from "./PreviewJobRibbon.vue?vue&type=template&id=372c7ba8&scoped=true"
import script from "./PreviewJobRibbon.vue?vue&type=script&lang=js"
export * from "./PreviewJobRibbon.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobRibbon.vue?vue&type=style&index=0&id=372c7ba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c7ba8",
  null
  
)

export default component.exports